import { api } from "./api";
import { joinUrl, normalizeBaseUrl } from "../utils/url";

const clientUrl = normalizeBaseUrl(process.env.REACT_APP_CLIENT_URL);

export const register = (email, password) =>
  api.post("/auth/register", {
    email,
    password,
    url: clientUrl,
  });

export const resendVerification = (email) =>
  api.post("/auth/resend-verification", {
    email,
    url: clientUrl,
  });

export const login = (email, password) =>
  api.post("/auth/login", {
    email,
    password,
  });

export const verifyEmail = (token) =>
  api.post(`/auth/verify-email/${encodeURIComponent(token)}`);

export const forgotPassword = (email) =>
  api.post("/auth/forgot-password", {
    email,
    url: clientUrl,
  });

export const resetPassword = (token, password) =>
  api.post("/auth/reset-password", {
    token,
    password,
  });

export const getGoogleAuthUrl = () => {
  const redirect = joinUrl(clientUrl, "/auth/google/callback");
  const authUrl = joinUrl(process.env.REACT_APP_SERVER_URL, "/auth/google");
  return `${authUrl}?redirect=${encodeURIComponent(redirect)}`;
};

export const applyAuthResponse = (response) => response.data;
